import { CSSProperties, ReactNode } from "react";

interface IGridRowProps {
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
}

const GridRow = (props: IGridRowProps) => {
  const { children, className = "", style } = props;

  return (
    <div className={`grid-container ${className}`} style={style}>
      {children}
    </div>
  );
};

export default GridRow;
